import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function LegalPage({ document: legalDocument }) {
  const navigateToSection = (sectionId) => {
    globalThis.document?.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="legal-container">
          <span className="legal-eyebrow">ProfitYo Global System™ · Legal</span>
          <h1>{legalDocument.title}</h1>
          <p>{legalDocument.intro}</p>
          <div className="legal-meta">Last Updated: [DATE]</div>
          <div className="legal-review-note" role="note">
            Bracketed text is a placeholder for management or legal review before publication.
          </div>
          <Link className="legal-home-link" to="/">
            Return to the ProfitYo Global website <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>

      <div className="legal-container legal-layout">
        <nav className="legal-toc" aria-label={`${legalDocument.title} sections`}>
          <span>On this page</span>
          {legalDocument.sections.map((section) => (
            <button
              key={section.id}
              type="button"
              onClick={() => navigateToSection(section.id)}
            >
              {section.title}
            </button>
          ))}
        </nav>

        <article className="legal-article">
          {legalDocument.sections.map((section, index) => (
            <section
              className="legal-section"
              id={section.id}
              key={section.id}
              aria-labelledby={`${section.id}-title`}
            >
              <div className="legal-section-number">{String(index + 1).padStart(2, '0')}</div>
              <div>
                <h2 id={`${section.id}-title`}>{section.title}</h2>
                {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                {section.bullets && (
                  <ul>
                    {section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
                  </ul>
                )}
              </div>
            </section>
          ))}
          <div className="legal-contact-card">
            <span>Questions or concerns?</span>
            <a href="mailto:inquiries@profityoglobal.com">inquiries@profityoglobal.com</a>
          </div>
        </article>
      </div>
    </div>
  );
}